/**
 * Mixin for handling bus event registrations
 * Automatically unregisters from all events on beforeDestroy
 *
 *
 * METHODS
 * -------
 *
 * getRegisteredBusEvents()
 * registerBusEvent(name, callback)
 * unregisterBusEvents()
 *
 *
 * EXAMPLES
 * --------
 *
 * Example 1 - with named method
 *
 * mixins: [ busEventsMixin ],
 * created(){
 *     this.registerBusEvent('event-name', this.listener);
 * },
 * methods:{
 *     listener(){
 *        // do something on event
 *     }
 * },
 *
 *
 * Example 2 - with anonymous funcion
 *
 * mixins: [ busEventsMixin ],
 * created(){
 *     this.registerBusEvent('event-name', function(param){
 *         ...
 *     });
 * },
 *
 */

const PM_event_bus = {};
PM_event_bus.install = function (Vue, options) {

    const EventBus = new Vue();

    Object.defineProperties(Vue.prototype, {
        $bus: {
            get: function() {
                return EventBus;
            },
        },
    });

    Vue.mixin({

        data: function() {
            return({
                registeredBusEvents: []
            });
        },

        methods: {

            /**
             * Returns the names of the registered events
             * @returns {Array|*}
             */
            getRegisteredBusEvents: function() {
                return this.registeredBusEvents;
            },

            /**
             * Registers a $bus event callback
             * @param name
             * @param callback
             * @returns void
             */
            registerBusEvent: function(name, callback) {
                if(typeof this.registeredBusEvents === 'undefined') this.registeredBusEvents = [];

                // If callback is an anonymous fn register it as named fn
                if (!callback.name) {
                    let cbName = 'busEventListener_' + name.replace(':','_').replace('-','_') + '_' + this.$options.name;
                    this[cbName] = callback;
                    callback = this[cbName];
                }

                this.registeredBusEvents.push({ event: name, callback: callback });
                this.$bus.$on(name, callback);
            },

            /**
             * Unregisters all registered events
             * @returns void
             */
            unregisterBusEvents: function() {
                for(let i in this.registeredBusEvents) {
                    this.$bus.$off(this.registeredBusEvents[i].event, this.registeredBusEvents[i].callback);
                }
                this.registeredBusEvents = [];
            },

            cleanupBusEvents: function() {
                for (let i in this.$bus._events) {
                    //if (!this.$bus._events.hasOwnProperty(i)) continue;
                    if (this.$bus._events[i] === null || this.$bus._events[i].length === 0) delete this.$bus._events[i];
                }
            },
        },

        beforeDestroy: function() {
            this.unregisterBusEvents();
            this.cleanupBusEvents();
        },
    });
};

export default PM_event_bus;
